import countriesAndCities from '../components/destination-selector/countries-and-cities';

const loginPageContentTabLsKey = 'triplan-login-page-content-tab';
const mainPageContentTabLsKey = 'triplan-main-page-content-tab';
const myTripsTabId = 'my-trips';
const exploreTabId = 'explore';
const mobileSuggestedTripsTabId = 'suggested-trips';
const mobileTopPicksTabId = 'top-picks';
const mobileSystemRecommendationsTabId = 'system-recommendations';
const savedCollectionsTabId = 'saved-collections';
const whatsNewTabId = 'whats-new';
const newDesignRootPath = '/v2';
const searchResultsTabId = 'search-results';
const specificItemTabId = 'view-item';

const cityImage = '/images/city.jpg';
const islandImage = '/images/island.png';

export const TEMPLATES_USER_NAME = 'templates';

const top100Cities = countriesAndCities.map((c) => c.value);

const top100CitiesOld2 = [
	'Reykjavik',
	'Bora Bora',
	'Queenstown',
	'Chiang Mai',
	'Santorini',
	'Seychelles',
	'Victoria Falls',
	'Amalfi Coast',
	'Dubrovnik',
	'Zanzibar',
	'Ibiza',
	'Maui',
	'Lake Bled',
	'Kruger National Park',
	'Petra',
	'Hoi An',
	'Siem Reap',
	'Buenos Aires',
	'Phuket',
	'Machu Picchu',
	'Kyoto',
	'Kyrenia',
	'Maldives',
	'Yellowstone',
	'Banff',
	'Galápagos Islands',
	'Whistler',
	'Patagonia',
	'Bali',
	'Grand Canyon',
	'Tahiti',
	'Angkor Wat',
	'Hallstatt',
	'Mykonos',
	'Saint Lucia',
	'Punta Cana',
	'Serengeti',
	'Hvar',
	'Tuscany',
	'Tasmania',
	'Corsica',
	'Tulum',
	'Goa',
	'Palawan',
	'Lapland',
	'Sapporo',
	'Cotswolds',
	'Mauritius',
	'Corfu',
	'The Algarve',
	'St. Barts',
	'Crete',
	'Moorea',
	'Chamonix',
	'Sedona',
	'St. Moritz',
	'Malta',
	'Cannes',
	'Monaco',
	'Nevis',
	'Big Sur',
	'Blue Mountains',
	'Cartagena',
	'Split',
	'Boracay',
	'Sardinia',
	'Aspen',
	'Porto',
	'The Hamptons',
	'Yosemite',
	'Lake Como',
	'Barbados',
	'Zakynthos',
	'Rotorua',
	'Newfoundland',
	'Namibia',
	'Antigua',
	'Sintra',
	'Saint-Tropez',
	'Whitsunday Islands',
	'Grenada',
	'Port Douglas',
	'Fraser Island',
	'Joshua Tree',
];

const top100CitiesOld = [
	'Paris',
	'Tokyo',
	'New York',
	'Rome',
	'Barcelona',
	'London',
	'Dubai',
	'Istanbul',
	'Bangkok',
	'Kyoto',
	'Florence',
	'Amsterdam',
	'Venice',
	'Singapore',
	'Lisbon',
	'Hong Kong',
	'Sydney',
	'Berlin',
	'Vienna',
	'Milan',
	'Prague',
	'Madrid',
	'Seoul',
	'Rio de Janeiro',
	'Cape Town',
	'Los Angeles',
	'Mexico City',
	'Copenhagen',
	'Munich',
	'Buenos Aires',
	'San Francisco',
	'Marrakesh',
	'Shanghai',
	'Edinburgh',
	'Budapest',
	'Lisbon',
	'Hanoi',
	'Beijing',
	'Stockholm',
	'Moscow',
	'Toronto',
	'Dublin',
	'Kuala Lumpur',
	'Vancouver',
	'Melbourne',
	'Lima',
	'San Diego',
	'Istanbul',
	'Bruges',
	'Osaka',
	'Tel Aviv',
	'Nice',
	'Jerusalem',
	'Naples',
	'Zürich',
	'Brussels',
	'Thailand',
	// "Ho Chi Minh City",
	'Warsaw',
	'Santiago',
	'Casablanca',
	'Brisbane',
	'Athens',
	'Helsinki',
	'Doha',
	'Abu Dhabi',
	'Valencia',
	'Seattle',
	'Quebec City',
	'Cairo',
	'Ljubljana',
	'Auckland',
	'Montevideo',
	'Kraków',
	'Salzburg',
	'Hamburg',
	'Perth',
	'Dubrovnik',
	'Porto',
	'Bratislava',
	'Reykjavik',
	'Cusco',
	'Fukuoka',
	'Palermo',
	'Oslo',
	'Chennai',
	'Antwerp',
	'Bali',
	'Phuket',
	'Malé',
	'Manila',
	'Kathmandu',
	'Jakarta',
	'Colombo',
	'Havana',
	'Zagreb',
	'Aix-en-Provence',
	'Guadalajara',
	'Cartagena',
	'Cape Town',
	'Bordeaux',
	'Nairobi',
	'Bogotá',
	'Málaga',
	'Luxembourg City',
	'Stuttgart',
	'Bergen',
	// added:
	'Rhodes',
];

export {
	top100Cities,
	top100CitiesOld,
	mainPageContentTabLsKey,
	loginPageContentTabLsKey,
	myTripsTabId,
	exploreTabId,
	newDesignRootPath,
	savedCollectionsTabId,
	whatsNewTabId,
	cityImage,
	islandImage,
	searchResultsTabId,
	specificItemTabId,
	mobileSuggestedTripsTabId,
	mobileSystemRecommendationsTabId,
	mobileTopPicksTabId,
};
